module.exports = __webpack_public_path__ + "static/media/bat-login-light.0bbb85de.png";